import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fullscreen-modal-header" }
const _hoisted_2 = { class: "fullscreen-modal-header__back" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right icon-rotate-180",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fullscreen-modal-header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/logo-color.svg",
    alt: "elements.at Home",
    class: "fullscreen-modal-header__logo-img"
  })
], -1)
const _hoisted_5 = { class: "fullscreen-modal-header__close" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-link-grey__icon",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-no-styling btn-link-grey",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.translate('general.go-back')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn-no-styling btn-link-grey",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
      }, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.translate('general.close')), 1)
      ])
    ])
  ]))
}